export function onEnterKey(callback) {
  return ({target, code, shiftKey}) => {
    if (!callback || code !== "Enter") {
      return
    }

    return callback({target, shift: shiftKey})
  }
}